import {WineItem} from "../../../MenuDocumentModel";
import {EditorItem, getWineItemShowAppellation, useUpdateProperty} from "../../../editorUtils";
import React, {ReactElement} from "react";
import {useAppSelector} from "../../../../../lib/redux/hooks";
import {menuEditorSelectors} from "../../../editorSlice";
import {FormattedMessage} from "react-intl";
import {SliderToggle} from "../../../../../components/UIComponents/SliderToggle";
import {FormGroup} from "../../../../../components/UIComponents/FormGroup";
import {FormInput} from "../../../../../components/UIComponents/FormInput";


export interface ShowAppellationControlProps {
    wine: EditorItem<WineItem>;
}

export function ShowAppellationControl(props: ShowAppellationControlProps): ReactElement {
    const document = useAppSelector(menuEditorSelectors.document);
    const updateProperty = useUpdateProperty(props.wine);
    if (!document) return <></>;

    const wineItem = props.wine.menuItem;
    const showAppellation = getWineItemShowAppellation(wineItem, document);

    return <>
        <div className="flex items-center gap-2">
            <span className="flex-auto text-sm">
                <FormattedMessage id="editor.format.showAppellation"/>
            </span>
            <div className="flex-none h-7 w-12">
                <SliderToggle
                    enabled={showAppellation}
                    setEnabled={val => updateProperty('showAppellation', val)}
                />
            </div>
        </div>
        {showAppellation &&
            <FormGroup groupTitle={<></>}>
                <FormInput
                    value={wineItem.appellation ?? ""}
                    onChange={e => updateProperty('appellation', e.target.value)}
                />
            </FormGroup>
        }
    </>;
}